import { useStaticQuery, graphql } from "gatsby";
import { UnileverLogoQuery } from "../../graphql-types";

const useUnileverLogo = () => {
  const { file } = useStaticQuery<UnileverLogoQuery>(graphql`
    query UnileverLogo {
      file(relativePath: { eq: "unilever-logo.png" }) {
        childImageSharp {
          gatsbyImageData(width: 200, placeholder: BLURRED, layout: CONSTRAINED)
        }
      }
    }
  `);

  return file;
};

export default useUnileverLogo;
